import { render, staticRenderFns } from "./AppTabBar.vue?vue&type=template&id=61296756&scoped=true&"
import script from "./AppTabBar.vue?vue&type=script&lang=js&"
export * from "./AppTabBar.vue?vue&type=script&lang=js&"
import style0 from "./AppTabBar.vue?vue&type=style&index=0&id=61296756&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61296756",
  null
  
)

export default component.exports